import { render, staticRenderFns } from "./DeliverySummary.vue?vue&type=template&id=59a479f3&scoped=true&"
import script from "./DeliverySummary.vue?vue&type=script&lang=js&"
export * from "./DeliverySummary.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySummary.vue?vue&type=style&index=0&id=59a479f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a479f3",
  null
  
)

export default component.exports